import { render } from "./TopIssue.vue?vue&type=template&id=92effec4&scoped=true&ts=true"
import script from "./TopIssue.vue?vue&type=script&lang=ts"
export * from "./TopIssue.vue?vue&type=script&lang=ts"

import "./TopIssue.vue?vue&type=style&index=0&id=92effec4&scoped=true&lang=css"

import exportComponent from "/home/runner/work/owt/owt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-92effec4"]])

export default __exports__